import Axios from "./interceptor";

const API_URL = process.env.REACT_APP_API_BASE_URL + "/api";

const getUsersBilling = async (usersId) => {
  const response = await Axios.get(
    `${API_URL}/users/usersbillingdata?usersId=${usersId}`,
  );
  return response;
};

export { getUsersBilling };
